import { Link } from "react-router-dom";
import { imagesForProduct } from "../data/productMedia.js";

const ProductCard = ({ product }) => {
  const image = imagesForProduct(product)[0];

  return (
    <Link
      to={`/${product.category}/${product.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg bg-containx-charcoal/30 text-white shadow-md transition hover:bg-containx-beige/50 hover:text-containx-navy"
    >
      {image ? (
        <img src={image} alt={product.name} loading="lazy" decoding="async" className="h-48 w-full object-contain p-3" />
      ) : (
        <div className="flex h-48 items-center justify-center bg-white/10 p-6 text-center text-2xl font-semibold">
          {product.name}
        </div>
      )}
      <div className="flex flex-1 flex-col p-4">
        <h2 className="text-xl font-semibold">{product.name}</h2>
        {product.description && <p className="mt-2 text-sm opacity-90">{product.description}</p>}
        <p className="mt-auto pt-4 text-sm font-semibold underline">View products</p>
      </div>
    </Link>
  );
};

export default ProductCard;
